import { render, staticRenderFns } from "./GoodsTypeList.vue?vue&type=template&id=76363d00&scoped=true"
import script from "./GoodsTypeList.vue?vue&type=script&lang=js"
export * from "./GoodsTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76363d00",
  null
  
)

export default component.exports